export const computeBorderClasses = (appearance) => {
    const borderColorClasses = 'twds-border-gray-300 dark:twds-border-gray-900';
    return appearance === 'default'
        ? `twds-border-0 twds-border-solid twds-border-b ${borderColorClasses}`
        : `twds-border-solid twds-border ${borderColorClasses} twds-rounded`;
};
export const computeTitleBorderClasses = (appearance) => {
    return appearance === 'card' && 'twds-rounded';
};
//# sourceMappingURL=accordion.logic.js.map